import { IFilter } from '../../types/filters';
import { SquareMeterAreaContainer } from '../../containers/advancedFilters/SquareMeterAreaContainer';

export const squareMeterArea: IFilter = {
  component: SquareMeterAreaContainer,
};
